// -----------------------------------------------------------------------
// <copyright file="FullSpinner.tsx" company="Microsoft">
//     copyright (c) Microsoft. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

import { ISpinnerStyles, Spinner } from '@fluentui/react';
import * as React from 'react';
import { getString } from '../../utils/stringLoader';

const FullSpinnerStyle: ISpinnerStyles = {
  root: { position: 'fixed', alignSelf: 'center', zIndex: 1000, height: '100%', width: '100%' },
  circle: { height: '70px', width: '70px', borderWidth: 4 },
};

export const FullSpinner = (): JSX.Element => {
  return <Spinner styles={FullSpinnerStyle} role="alert" aria-label={getString('GetHelp_Loading')} />;
};
